import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  imports: [BrowserAnimationsModule, CommonModule],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class DashboardCoreModule {
  private parentModule = inject(DashboardCoreModule, { optional: true, skipSelf: true });

  /**
   * Prevents re-importing of CoreModule in non-root modules.
   *
   * The constructor tells Angular to inject the CoreModule into itself.
   * @Optional  Means not finding the service is ok.
   * @SkipSelf  Looks for the module in an ancestor injector (above it in the injector hierarchy).
   */
  public constructor() {
    /**
     * When this executes as intended in the application's root module, the parentModule variable
     * is null since there is no ancestor injector.
     */
    if (this.parentModule) {
      throw new Error('CoreModule already loaded. Only import it once for app root injector!');
    }
  }
}
